import ForResearcher from './ForResearcher';

export default ForResearcher;
